import axios from 'axios';
import { Toast } from 'vant';

//获取协议
// const protocol = window.location.protocol;
// 创建axios实例
const service = axios.create({
  baseURL: 'https://admin.89mc.com', // 基准地址  
  // baseURL: '/api', // 基准地址  
  // baseURL: '/adminApi', // 基准地址  
  timeout: 10000, // 超时时间
  // withCredentials: true, //携带cookie
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }
})


// request拦截器
service
  .interceptors
  .request
  .use(config => {
    // 设置请求头 添加token
    if (localStorage.getItem('TOKEN_KEY')) {
      config.headers.Authorization = localStorage.getItem('TOKEN_KEY');
    }
    return config;
  },
    error => {
      console.log('error:', error);
      Toast({
        message: '出错啦~，请刷新页面重试~',
        type: 'fail',
        duration: 3 * 1000
      });
    });


// respone拦截器
service.interceptors.response.use((res) => {
  if (res.data.status === 403) {
    Toast({
      message: res.msg,
      type: 'error',
      duration: 3 * 1000
    });
    localStorage.removeItem('TOKEN_KEY');
    // let url = `login`;
    // this.router.push(url);
    // this.$router.push('/login')
  } else {
    //返回响应数据
    return res
  }
}, error => {
  if (error.response && error.response.data && error.response.data.code === 10002) {
    localStorage.removeItem('TOKEN_KEY');
    // let url = `login`;
    // this.router.push(url);
    // this.router.push('/login')
  } else {
    Toast({
      message: error.msg,
      type: 'error',
      duration: 3 * 1000
    });
  }
  return Promise.reject(error)
}
)


export default service;

